export const onConvertData = (data: any) => ({
    phieuDieuTri: data,
    provisionalDiagnosis: data?.diagnosisCoded,
    provisionalDiagnosisName: data?.diagnosisCodedName,
    comorbidity: data?.comorbidity,
    diagnosisNonCoded: data?.diagnosisNonCoded,
});